import { Team } from './team';

export const MOCKTEAMS: Team[] = [
  {
    name: 'Teamname',
    category: 'incremental',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut imperdiet mi nec tellus scelerisque auctor ut ac arcu. ',
    member: ['Ann-Marget', 'Donald Duck']
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/strategy-overview/teams/mock-teams.ts